import { PublicKey } from "@solana/web3.js";

export const JUPITER_V6_PROGRAM: PublicKey = new PublicKey(
  "JUP6LkbZbjS1jKKwapdHNy74zcZ3tLUZoi5QNyVTaV4"
);
export const SINGLE_POOL_PROGRAM_ID: PublicKey = new PublicKey(
  "SVSPxpvHdN29nkVg9rPapPNDddN5DipNLRUFhyjFThE"
);
export const STAKE_PROGRAM_ID: PublicKey = new PublicKey(
  "Stake11111111111111111111111111111111111111"
);
export const MPL_METADATA_PROGRAM_ID: PublicKey = new PublicKey(
  "metaqbxxUerdq28cj1RbAWkYQm3ybzjb6a8bt518x1s"
);
export const SYSTEM_PROGRAM_ID: PublicKey = new PublicKey("11111111111111111111111111111111");
export const SYSVAR_RENT_ID: PublicKey = new PublicKey(
  "SysvarRent111111111111111111111111111111111"
);
export const SYSVAR_CLOCK_ID: PublicKey = new PublicKey(
  "SysvarC1ock11111111111111111111111111111111"
);
export const SYSVAR_STAKE_HISTORY_ID: PublicKey = new PublicKey(
  "SysvarStakeHistory1111111111111111111111111"
);
export const STAKE_CONFIG_ID: PublicKey = new PublicKey(
  "StakeConfig11111111111111111111111111111111"
);
